export default __webpack_public_path__ + "static/media/tartagal.fe35e4a6.jpg";